/* eslint-disable */
import { Component } from 'react';
import Message from '../../components/MessageCustom';
import { isTrue } from '../../helpers/isTrue';
import { shouldPromoteFreeAiTracking } from '../../helpers/upgradeUrl';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import Banner from './banner';

class OverviewErros extends Component {
    constructor(props) {
        super();

        this.getPermissions = this.getPermissions.bind(this);
        this.getSubscription = this.getSubscription.bind(this);

        if (props.domains) {
            this.domains = JSON.parse(props.domains);
        }

        this.isShownButton = this.isShownButton.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);

        const existingUsersData = localStorage.getItem('subscriptions')
            ? JSON.parse(localStorage.getItem('subscriptions'))
            : {};

        this.state = {
            show: false,
            isDark: !!JSON.parse(localStorage.getItem('dark-mode')),
            user_permissions: window?.user_permissions ? { ...window?.user_permissions } : {},
            user_subscription_info: existingUsersData[window.info.user] ?? {},
        };
    }

    componentDidMount() {
        this.isShownButton();
        document.addEventListener('getPermissionsEvent', this.getPermissions);
        document.addEventListener('getSubscriptionEvent', this.getSubscription);
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    componentWillUnmount() {
        document.removeEventListener('getPermissionsEvent', this.getPermissions);
        document.removeEventListener('getSubscriptionEvent', this.getSubscription);
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        this.setState({ isDark: !!JSON.parse(localStorage.getItem('dark-mode')) });
    }

    getPermissions() {
        const data = window?.user_permissions ? { ...window?.user_permissions } : {};
        this.setState({
            user_permissions: data,
        });
    }

    getSubscription() {
        const data = window?.user_subscription_info ? { ...window?.user_subscription_info } : {};
        this.setState({
            user_subscription_info: data,
        });
    }

    isShownButton() {
        if (isTrue(this.props.is_deactivated) || isTrue(this.props.is_viewer_user)) {
            return;
        }

        if (!isTrue(this.props.linked_accounts)) {
            const message =
                "You haven't connected the app to GSC, please connect you Google Search Console account.";
            this.setState({
                message,
                header: 'ALERT',
                show: true,
                message_type: 'alert-danger',
                link: '/customers/link',
                link_name: 'Connect GSC',
            });
            return;
        }

        if (this.domains?.length === 0) {
            const message = "You haven't added any domains yet to the app, please add a domain.";
            this.setState({
                message,
                header: 'ALERT',
                show: true,
                message_type: 'alert-danger',
                link: '/domains/link/',
                link_name: 'Add domains',
            });
            return;
        }
        const activeDomain = this.domains?.find((item) => item.active);
        if (!activeDomain) {
            const message =
                "You haven't activated any domain yet, please activate one of your domains.";
            this.setState({
                message,
                header: 'ALERT',
                message_type: 'alert-danger',
                show: true,
                link: '/settings/',
                link_name: 'Activate your domains',
            });
            return;
        }
    }

    render() {
        const { t } = this.props;

        // The free AI Tracking offer is shown to every user who is not already entitled to AI
        // Tracking, not just legacy (old-billing) users.
        const showFreeAiTracking = shouldPromoteFreeAiTracking(this.state.user_permissions);

        let trialMessage = null;
        if (this.state.user_permissions?.subscription_status === 'trialing') {
            trialMessage = (
                <ul>
                    {this.state.user_permissions?.discover_analytics && (
                        <li className="mt-6">
                            {t('page_all_domain.messages.trial.discover_analysis')}
                        </li>
                    )}
                    {this.state.user_permissions?.search_analytics && (
                        <li className="mt-6">
                            {t('page_all_domain.messages.trial.search_analysis')}
                        </li>
                    )}
                    {this.state.user_permissions?.ai_tracking && (
                        <li className="mt-6">
                            <div>
                                {t('page_all_domain.messages.trial.ai_tracking')}
                                <a
                                    className="link-in-text ml-6"
                                    href="/ai-tracking/prompt-generator/"
                                >
                                    {t('page_all_domain.messages.trial.start_tracking')}
                                </a>
                            </div>
                        </li>
                    )}
                </ul>
            );
        }

        return (
            <>
                {this.state.show && (
                    <Message
                        header={this.state.header}
                        message={this.state.message}
                        link={this.state.link}
                        link_name={this.state.link_name}
                        message_type={this.state.message_type}
                    />
                )}
                {this.state.user_permissions?.subscription_status === 'trialing' && (
                    <Message
                        header={t('page_all_domain.messages.trial.header', {
                            trial_end_date: moment(this.state.user_permissions?.trial_end).format(
                                'MMMM DD YYYY HH:mm',
                            ),
                        })}
                        message={trialMessage}
                        message_type={'alert-info'}
                    />
                )}
                {showFreeAiTracking && <Banner />}
            </>
        );
    }
}

export default withTranslation()(OverviewErros);
